import { IEndpoint } from 'interfaces/IEndPoint';
import AuthProtect from '../common/enums/AuthProtect';

export const getNotificationByRequest = (requestId: string): IEndpoint => {
  return {
    authorization: AuthProtect.REQUIRED,
    method: 'GET',
    url: `notification/request/${requestId}`,
  };
};

export const sendRemindByAgency = (requestId: string, agencyId: string): IEndpoint => {
  return {
    authorization: AuthProtect.REQUIRED,
    method: 'GET',
    url: `notification/${requestId}/notify/${agencyId}`,
  };
};

export const sendRemindAll = (requestId: string): IEndpoint => {
  return {
    authorization: AuthProtect.REQUIRED,
    method: 'GET',
    url: `notification/${requestId}/notify`,
  };
};
